import {
    ADD_MEETING,
    ADD_MESSAGE,
    COMPLETE_MEETING,
    COMPLETE_MESSAGE,
    COMPLETE_TUTORIAL,
    PROGRESS_DAY,
    PROGRESS_TIME,
    REMOVE_PHONE_CALL,
    EXIT_GAME,
    RESET_TUTORIALS,
    SET_CALENDAR,
    SET_ALL_MEETINGS,
    SET_ALL_MESSAGES,
    SET_MEETINGS_INDEXES,
    SET_MESSAGES_INDEXES,
    SET_PHONE_CALL,
    UPDATE_OVERALL_SCORES,
    SUBMIT_GAME_PLAYED,
    FAIL_WEEK,
} from '../constants/actions';
import {
    DEBATE_GAME_SCREEN,
    INQUIRY_GAME_SCREEN,
    MEETINGS_GAME_SCREEN,
    MESSAGES_GAME_SCREEN,
    PRESS_GAME_SCREEN,
    QUESTIONS_GAME_SCREEN,
    SPEAKER_GAME,
    VOTE_GAME_SCREEN,
} from '../constants/routes';

const defaultRouter = {
    currentDay: 0,
    currentTime: 0,
    calendar: [],
    gamesPlayedTracker: {
        0: [],
        1: [],
        2: [],
        3: [],
        4: [],
    },
    currentCall: null,
    currentMessages: [],
    messagesIndexes: [],
    currentMeetings: [],
    meetingsIndexes: [],
    tutorialsCompleted: {
        [MESSAGES_GAME_SCREEN]: false,
        [MEETINGS_GAME_SCREEN]: false,
        [INQUIRY_GAME_SCREEN]: false,
        [DEBATE_GAME_SCREEN]: false,
        [PRESS_GAME_SCREEN]: false,
        [VOTE_GAME_SCREEN]: false,
        [QUESTIONS_GAME_SCREEN]: false,
        [SPEAKER_GAME]: false,
    },
    overallScores: {
        party: 0,
        voters: 0,
        media: 0,
    },
    failed: false,
};

export const activeGame = (state = defaultRouter, action) => {
    switch (action.type) {
        case COMPLETE_TUTORIAL:
            return {
                ...state,
                tutorialsCompleted: {
                    ...state.tutorialsCompleted,
                    [action.screen]: true,
                },
            };
        case RESET_TUTORIALS:
            return {
                ...state,
                tutorialsCompleted: defaultRouter.tutorialsCompleted,
            };
        case PROGRESS_TIME:
            return {
                ...state,
                currentTime: state.currentTime + 1,
            };
        case PROGRESS_DAY:
            return {
                ...state,
                currentDay: state.currentDay + 1,
                currentTime: 0,
            };
        case SUBMIT_GAME_PLAYED:
            return {
                ...state,
                gamesPlayedTracker: {
                    ...state.gamesPlayedTracker,
                    [state.currentDay]: [
                        ...state.gamesPlayedTracker[state.currentDay],
                        action.gamePlayed,
                    ],
                },
            };
        case UPDATE_OVERALL_SCORES:
            return {
                ...state,
                overallScores: action.overallScores,
            };
        case EXIT_GAME:
            return {
                ...state,
                overallScores: defaultRouter.overallScores,
                currentDay: 0,
                currentTime: 0,
                calendar: [],
                gamesPlayedTracker: defaultRouter.gamesPlayedTracker,
                currentCall: null,
                currentMessages: [],
                messagesIndexes: [],
                currentMeetings: [],
                meetingsIndexes: [],
                failed: false,
            };
        case SET_CALENDAR:
            return {
                ...state,
                calendar: action.calendar,
            };
        case SET_PHONE_CALL:
            return {
                ...state,
                currentCall: action.currentCall,
            };
        case REMOVE_PHONE_CALL:
            return {
                ...state,
                calendar: action.newCalendar,
                currentCall: null,
            };
        case SET_MESSAGES_INDEXES:
            return {
                ...state,
                messagesIndexes: action.messagesIndexes,
                currentMessages: [...action.presetMessages],
            };
        case SET_ALL_MESSAGES:
            return {
                ...state,
                messagesIndexes: action.messages,
                currentMessages: action.messages,
            };
        case ADD_MESSAGE:
            return {
                ...state,
                currentMessages: [...state.currentMessages, action.message],
                messagesIndexes: state.messagesIndexes.filter(
                    message => message !== action.message,
                ),
            };
        case COMPLETE_MESSAGE:
            return {
                ...state,
                currentMessages: state.currentMessages.filter(
                    messageIndex => messageIndex !== action.messageIndex,
                ),
            };
        case SET_MEETINGS_INDEXES:
            return {
                ...state,
                meetingsIndexes: action.meetingsIndexes,
                currentMeetings: [...action.presetMeetings],
            };
        case SET_ALL_MEETINGS:
            return {
                ...state,
                meetingsIndexes: action.meetings,
                currentMeetings: action.meetings,
            };
        case ADD_MEETING:
            return {
                ...state,
                currentMeetings: [...state.currentMeetings, action.meeting],
                meetingsIndexes: state.meetingsIndexes.filter(
                    message => message !== action.meeting,
                ),
            };
        case COMPLETE_MEETING:
            return {
                ...state,
                currentMeetings: state.currentMeetings.filter(
                    meetingIndex => meetingIndex !== action.meetingIndex,
                ),
            };
        case FAIL_WEEK:
            return {
                ...state,
                failed: true,
            };
        default:
            return state;
    }
};
